import React, { createContext, useContext, useState, useCallback, useEffect } from "react";
import { translations } from "@/data/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const [favorites, setFavorites] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mr_favorites") || "[]"); } catch { return []; }
  });
  // Dati trasferiti dalla quick search al booking engine
  const [bookingPrefill, setBookingPrefill] = useState(null);
  // Filtro strutture attivato dalle destinazioni
  const [propFilter, setPropFilter] = useState("Tutte");

  useEffect(() => {
    localStorage.setItem("mr_favorites", JSON.stringify(favorites));
  }, [favorites]);

  const t = translations[lang];

  const toggleFavorite = useCallback((id) => {
    setFavorites((prev) => (prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id]));
  }, []);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <AppContext.Provider value={{ lang, setLang, t, favorites, toggleFavorite, bookingPrefill, setBookingPrefill, propFilter, setPropFilter, scrollToId }}>
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => useContext(AppContext);
